module.exports = __webpack_public_path__ + "static/media/IMG_5040.8d541d9e.JPG";